import { DatePicker as ArkUiDatePicker } from "@ark-ui/react";
import Header from "./Header";
import { Text } from "../../typography/Text";
import { AromaDatepickerRecipe } from "@zenchef/styled-system/recipes";
import DayButton from "./DayButton";
import { Translations } from "./types";
import isDefaultDate from "./functions/isDefaultDate";
import isFocusedDate from "./functions/isFocusedDate";

interface Props {
  classes: ReturnType<AromaDatepickerRecipe>;
  defaultValue: ArkUiDatePicker.RootProps["defaultValue"];
  focusedValue?: ArkUiDatePicker.RootProps["focusedValue"];
  withDoubleArrows: boolean;
  translations: Translations;
}

export default function DayView({
  classes,
  defaultValue = [],
  focusedValue,
  withDoubleArrows,
  translations,
}: Props) {
  return (
    <ArkUiDatePicker.View view="day" className={classes.view}>
      <ArkUiDatePicker.Context>
        {(datePicker) => (
          <>
            <Header
              datePicker={datePicker}
              classes={classes}
              withDoubleArrows={withDoubleArrows}
              translations={translations}
            />
            <ArkUiDatePicker.Table className={classes.table}>
              <ArkUiDatePicker.TableHead>
                <ArkUiDatePicker.TableRow className={classes.row}>
                  {datePicker.weekDays.map((weekDay, id) => (
                    <ArkUiDatePicker.TableHeader
                      key={id}
                      className={classes.weekday}
                    >
                      <Text
                        textStyle="mono.s.regular"
                        color="content.neutral.base.subtlest"
                      >
                        {weekDay.short}
                      </Text>
                    </ArkUiDatePicker.TableHeader>
                  ))}
                </ArkUiDatePicker.TableRow>
              </ArkUiDatePicker.TableHead>
              <ArkUiDatePicker.TableBody className={classes.body}>
                {datePicker.weeks.map((week, id) => (
                  <ArkUiDatePicker.TableRow key={id} className={classes.row}>
                    {week.map((day, id) => (
                      <ArkUiDatePicker.TableCell key={id} value={day}>
                        <ArkUiDatePicker.TableCellTrigger
                          data-focus-value={
                            isFocusedDate(day, focusedValue) || undefined
                          }
                          data-default-value={
                            isDefaultDate(day, defaultValue) || undefined
                          }
                          asChild
                        >
                          <DayButton day={day.day} />
                        </ArkUiDatePicker.TableCellTrigger>
                      </ArkUiDatePicker.TableCell>
                    ))}
                  </ArkUiDatePicker.TableRow>
                ))}
              </ArkUiDatePicker.TableBody>
            </ArkUiDatePicker.Table>
          </>
        )}
      </ArkUiDatePicker.Context>
    </ArkUiDatePicker.View>
  );
}
